export default __webpack_public_path__ + "static/media/kitchen3-afterD-1920w.0cb91ffe.png";